import React, { createContext, useContext } from "react";
import useWorkspaces from "../hooks/useWorkspaces";
import { useAuth } from "./AuthContext"; 

const WorkspacesContext = createContext(null);

export function WorkspacesProvider({ children }) {
  const { user } = useAuth(); 
  const ws = useWorkspaces(user); 
  return (
    <WorkspacesContext.Provider value={ws}>
      {children}
    </WorkspacesContext.Provider>
  );
}

export function useWorkspacesContext() {
  const ctx = useContext(WorkspacesContext);
  if (!ctx) throw new Error("useWorkspacesContext must be used within <WorkspacesProvider>");
  return ctx;
}
